import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import API_ENDPOINTS from '../api-endpoints';
import {
  deleteComment,
  getCommentListByCategoryForeignIdx,
  patchCommentContents,
  postComment,
} from './comment';
import {
  CommentListQueryType,
  CommentPostType,
  PatchCommentParmsType,
} from './types';

/**
 * POST
 * /comment
 * 회원 댓글 등록 API 뮤테이션
 */
export const usePostCommentMutation = () => {
  return useMutation({
    mutationFn: (body: CommentPostType) => postComment(body),
  });
};

/**
 * GET
 * /comment/{category}/{foreignIdx}
 * 댓글 리스트 조회 API 쿼리
 */
export const useCommentListQuery = ({
  params,
  useQueryOptions,
}: CommentListQueryType) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.COMMENT_LIST, params],
    queryFn: () => getCommentListByCategoryForeignIdx(params),
    ...useQueryOptions,
  });
};

/** 게시글 리스트 갱신 */
export const useInvalidateCommentList = () => {
  const queryClient = useQueryClient();
  const invalid = () => {
    queryClient.invalidateQueries({
      queryKey: [API_ENDPOINTS.COMMENT_LIST],
    });
  };
  return invalid;
};

/**
 * PATCH
 * /comment/{idx}
 * 회원 댓글 수정 API 뮤테이션
 */
export const usePatchCommentContentsMutation = () => {
  return useMutation({
    mutationFn: ({
      commentIdx,
      body,
    }: {
      commentIdx: string;
      body: PatchCommentParmsType;
    }) => patchCommentContents(commentIdx, body),
  });
};

/**
 * DELETE
 * /comment/{idx}
 * 회원 댓글 삭제 뮤테이션
 */

export const useDeleteCommentMutation = () => {
  return useMutation({
    mutationFn: ({ commentIdx }: { commentIdx: string }) =>
      deleteComment(commentIdx),
  });
};
